import styled from 'styled-components';

export default styled.p`
  font-size: 16px;
  line-height: 20px;
  color: var(--black);
  width: 100%;
  margin: 0;
`;
